export default function () {
  if (
    document.querySelector('.single .ArticleContent .TableOfContents') &&
    Array.from(
      document.querySelectorAll(
        '.single .ArticleContent__entry h2 em, .single .ArticleContent__entry h3 em'
      )
    ).length > 0
  ) {
    import(
      /* webpackChunkName: "table-of-contents-module" */ './table-of-contents'
    ).then((module) => {
      const TableOfContents = module.default
      TableOfContents()
    })
  }
}
